<template>
    <div class="print-sub-header">
        <div>{{ selectedSlide.esId }}</div>
        <div class="v-divider" />
        <div>{{ $translate('age') }} {{ patientAge }}</div>
        <div class="v-divider" />
        <fertilization-time :hours="selectedTreatment.hoursSinceFertilization" />
        <div class="v-divider" />
        <div>Treatment {{ selectedTreatment.esId }}</div>
        <div class="v-divider" />
        <treatment-start-date :date="selectedTreatment.startDate" />
        <div class="v-divider" />
        <medical-decision-summary :wells="selectedTreatment.wellsByIndex" />
        <div class="v-divider" />
        <items-count :slides="selectedTreatment.slides" :wells="selectedTreatment.wellsByIndex" />
    </div>
</template>

<script>
import FertilizationTime from '../partials/FertilizationTime'
import TreatmentStartDate from '../partials/TreatmentStartDate'
import MedicalDecisionSummary from '../partials/MedicalDecisionSummary'
import ItemsCount from '../partials/ItemsCount'
import { mapGetters, mapState } from 'vuex'
export default {
    name: 'PrintSubHeader',
    components: { ItemsCount, MedicalDecisionSummary, TreatmentStartDate, FertilizationTime },
    computed: {
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        ...mapState({
            selectedSlide: state => state.timelapse.selectedSlide,
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        patientAge() {
            const { patientAge: ageInMonths } = this.selectedTreatment

            if (isNaN(ageInMonths)) return ageInMonths

            if (!ageInMonths) return this.$translate('na')

            const years = Math.floor(ageInMonths / 12)
            const months = Math.floor(ageInMonths % 12)

            return `${years}.${months}`
        }
    }
}
</script>

<style lang="scss" scoped>
.print-sub-header {
    height: $sub-header-height;
    border-top: 1px solid $light-alpha;
    border-bottom: 1px solid $light-alpha;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;

    .v-divider {
        border-right: solid 0.1rem $light-alpha;
        height: 40%;
        padding-left: 1rem;
        margin-right: 1rem;
    }
}
</style>
<style lang="scss">
.print-sub-header {
    .age-info .age-value,
    .fertilization-time,
    .treatment-status.ongoing,
    .treatment-status.finished,
    .treatment-start-date,
    .medical-decision-summary,
    .items-count .value {
        color: $dark-6 !important;
    }
    .medical-decision-summary .decision-option i {
        &.fa-times {
            -webkit-text-stroke: 0.16rem $light-3 !important;
        }
        &.fa-check {
            -webkit-text-stroke: 0.1rem $light-3 !important;
        }
    }
}
</style>
